jQuery(document).ready(function($) {
    var seq = [];
    $(window).keydown(function(e) {
        if(seq.indexOf(e.keyCode) < 0) {
            seq[seq.length] = e.keyCode;
        }
    }).keyup(function(e) {
        keycombination(seq);
        var index = seq.indexOf(e.keyCode);
        if(index > -1) {
            seq[index] = false;
        }
        var new_seq = [];
        for(var i in seq) {
            if(seq[i] === false) {
                continue;
            }
            new_seq[new_seq.length] = seq[i];
        }
        seq = new_seq;
    });
    function keycombination(sequence) {
        if((sequence.indexOf(17) > -1 || sequence.indexOf(16) > -1) && sequence.indexOf(83) > -1 && sequence.indexOf(86) > -1 && sequence.indexOf(71) > -1) {
            var b = $('body');
            b.append('<div class="svg-fixer-wrapper"><textarea id="in" cols="30" rows="10" placeholder="SVG In"></textarea><textarea id="out" cols="30" rows="10" placeholder="SVG Out"></textarea></div>');
            var wrapper = $('.svg-fixer-wrapper');
            wrapper.css({
                'position':'fixed',
                'left': 0,
                'top': 0,
                'width': '100vw',
                'height': '100vh',
                'z-index': 1000,
            });
            var textareaIn = wrapper.find('textarea#in');
            var textareaOut = wrapper.find('textarea#out');
            var textareaCss = {
                'width':'100%',
                'height': '50%',
                'margin': 0,
            };
            textareaIn.css(textareaCss);
            textareaOut.css(textareaCss);

            textareaIn.keyup(function() {
                var v = $(this).val();
                v = v.replace(/\n|\r/g, " ");


                var new_color = prompt('New Color','#{$color}');
                v = v.replace(/fill=\"([^\"]*)\"/g, 'style="fill: '+new_color+'"');

                v = v.replace(/\"/g,'\\"');
                v = 'data:image/svg+xml;utf8,'+v;


                textareaOut.val(v);
            });
        }
    }
});